/** cloud **/
export const CRIMETREE = 'CRIMETREE' // 案由
export const LAWCATEGORYTREE = 'LAWCATEGORYTREE'
export const LOADING = 'LOADING'
export const SELECTEDCRIME = 'SELECTEDCRIME'
export const SELECTEDLAWCATEGORY = 'SELECTEDLAWCATEGORY'

/** mine **/
export const CHARGETREE = 'CHARGETREE'
export const SELECTEDCHARGE = 'SELECTEDCHARGE'
export const SETCASEPICKTYPE = 'SETCASEPICKTYPE'



// WEBPACK FOOTER //
// ./src/store/types.js